/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnumerationDataPointDetailsDto } from './EnumerationDataPointDetailsDto';
import {
    instanceOfEnumerationDataPointDetailsDto,
    EnumerationDataPointDetailsDtoFromJSON,
    EnumerationDataPointDetailsDtoFromJSONTyped,
    EnumerationDataPointDetailsDtoToJSON,
} from './EnumerationDataPointDetailsDto';
import type { NumericDataPointDetailsDto } from './NumericDataPointDetailsDto';
import {
    instanceOfNumericDataPointDetailsDto,
    NumericDataPointDetailsDtoFromJSON,
    NumericDataPointDetailsDtoFromJSONTyped,
    NumericDataPointDetailsDtoToJSON,
} from './NumericDataPointDetailsDto';

/**
 * @type DataPointDetailsDto
 * 
 * @export
 */
export type DataPointDetailsDto = { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared' } & EnumerationDataPointDetailsDto | { $type?: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared' } & NumericDataPointDetailsDto;


export function DataPointDetailsDtoFromJSON(json: any): DataPointDetailsDto {
    return DataPointDetailsDtoFromJSONTyped(json, false);
}

export function DataPointDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointDetailsDto {
    if (json == null) {
        return json;
    }
    switch (json['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, EnumerationDataPointDetailsDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared':
            return Object.assign({}, NumericDataPointDetailsDtoFromJSONTyped(json, true), { $type: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared' } as const);
        default:
            throw new Error(`No variant of DataPointDetailsDto exists with '$type=${json['$type']}'`);
    }
}

export function DataPointDetailsDtoToJSON(value?: DataPointDetailsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['$type']) {
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared':
            return EnumerationDataPointDetailsDtoToJSON(value);
        case 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.NumericDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared':
            return NumericDataPointDetailsDtoToJSON(value);
        default:
            throw new Error(`No variant of DataPointDetailsDto exists with '$type=${value['$type']}'`);
    }

}

/**
 * Check if a given object implements the DataPointDetailsDto interface.
 */
export function instanceOfDataPointDetailsDto(value: any): value is DataPointDetailsDto {
    if (instanceOfEnumerationDataPointDetailsDto(value)) return true;
    if (instanceOfNumericDataPointDetailsDto(value)) return true;
    return false;
}

